type ModalType = 'terms' | 'privacy'

interface TermsModalState {
  isVisible: boolean
  type: ModalType
}

export const useTermsModal = () => {
  const state = useState<TermsModalState>('termsModal', () => ({
    isVisible: false,
    type: 'terms' as ModalType,
  }))

  const show = (type: ModalType = 'terms') => {
    state.value.type = type
    state.value.isVisible = true
  }

  const hide = () => {
    state.value.isVisible = false
  }

  return {
    state,
    show,
    hide,
  }
}
